<template>


    <div class="casco-policy">
        <Success :customername="data.cascoPolicyData.customername"
                 :rowid="this.rowid"
                 :generalnumber="data.cascoPolicyData.generalnumber"
                 :managerName="data.cascoPolicyData.nmG_NAME_A +' '+ data.cascoPolicyData.mnG_LASTNAME"
                 :managerPhone="data.cascoPolicyData.mnG_PHONE"
                 :managerEmail="data.cascoPolicyData.mnG_EMAIL"
                 :managerPhoto="data.cascoPolicyData.mnG_PHOTO" v-if="showSuccess" />

        <div v-if="showCancel == true">
            <h1 class="text-center col-10 offset-1 mt-5 graphic" style="font-size: 25px; color: #007960; ">
                <span>სამწუხაროდ, თქვენი კომპანიის კუთვნილი ავტოპარკის პოლის(ებ)ი არ გაქტიურდა.</span> <br />
                <span>
                    დაზღვევის ხელახლა გასაფორმებლად გთხოვთ, დაუკავშირდეთ თქვენს პირად მენეჯერს -
                    {{ data.cascoPolicyData.nmG_NAME_A }} {{ data.cascoPolicyData.mnG_LASTNAME }}
                </span> <br />
                მობ: {{ data.cascoPolicyData.mnG_PHONE }}<br />
                ელ.ფოსტა :  {{ data.cascoPolicyData.mnG_EMAIL }}
            </h1>
        </div>
        <div v-if="approvedLink== true">
            <div>
                <h3 class="text-center col-10 offset-1 mt-5" style="color: #007960; ">
                    <span>ელ.პოლისის ლინკი დადასტურებულია</span> <br />
                    თქვენი სადაზღვევო მრჩეველია - {{ data.cascoPolicyData.nmG_NAME_A }} {{ data.cascoPolicyData.mnG_LASTNAME }}<br />
                    მობ: {{ data.cascoPolicyData.mnG_PHONE }}<br />
                    ელ.ფოსტა: {{ data.cascoPolicyData.mnG_EMAIL }}
                </h3>
            </div>
        </div>


        <div v-if="canceledLink== true">
            <div>
                <h3 class="text-center col-10 offset-1 mt-5" style="color: #007960; ">
                    <span>ელ.პოლისის ლინკი გაუქმებულია</span> <br />
                    თქვენი სადაზღვევო მრჩეველია - {{ data.cascoPolicyData.nmG_NAME_A }} {{ data.cascoPolicyData.mnG_LASTNAME }}<br />
                    მობ: {{ data.cascoPolicyData.mnG_PHONE }}<br />
                    ელ.ფოსტა: {{ data.cascoPolicyData.mnG_EMAIL }}
                </h3>
            </div>
        </div>


        <div class="page" v-if="data && !showSuccess && !showCancel && !canceledLink && !approvedLink">
            <div class="tplc-policy__header">
                <div class="graphic"></div>
                <div class="title"><h1>ავტოტრანსპორტის დაზღვევის კორპორაციული პოლისის დასადასტურებელი ვერსია</h1></div>
            </div>
            <div class="page-padding">
                <table>
                    <tbody>
                        <tr>
                            <td>
                                <div class="info-item">
                                    <div class="info-item__title">მზღვეველი</div>
                                    <div class="info-item__content">
                                        <div class="info-item__content--list">
                                            <div class="info-item__content--list-item">
                                                <div class="bg-green">სახელწოდება</div>
                                                <div class="bg-gray">{{data.cascoPolicyData.compname}}</div>
                                            </div>
                                            <div class="info-item__content--list-item">
                                                <div class="bg-green">ს.კ</div>
                                                <div class="bg-gray">{{data.cascoPolicyData.compsoccart}}</div>
                                            </div>
                                            <div class="info-item__content--list-item">
                                                <div class="bg-green">ელფოსტა</div>
                                                <div class="bg-gray"><a href="mailto:office@ardi.ge">{{data.cascoPolicyData.compmail}}</a></div>
                                            </div>
                                            <div class="info-item__content--list-item">
                                                <div class="bg-green">ტელეფონი</div>
                                                <div class="bg-gray">032 {{data.cascoPolicyData.compphone}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="info-item">
                                    <div class="info-item__title">დამზღვევი</div>
                                    <div class="info-item__content">
                                        <div class="info-item__content--list">
                                            <div class="info-item__content--list-item">
                                                <div class="bg-green">სახელწოდება</div>
                                                <div class="bg-gray">{{data.cascoPolicyData.customername}}</div>
                                            </div>
                                            <div class="info-item__content--list-item">
                                                <div class="bg-green">ს.კ</div>
                                                <div class="bg-gray">{{data.cascoPolicyData.customersoccard}}</div>
                                            </div>
                                            <div class="info-item__content--list-item">
                                                <div class="bg-green">ელფოსტა</div>
                                                <div class="bg-gray"><a href="mailto:data.cascoPolicyData.cusT_MAIL">{{data.cascoPolicyData.cusT_MAIL}}</a></div>
                                            </div>
                                            <div class="info-item__content--list-item">
                                                <div class="bg-green">ტელეფონი</div>
                                                <div class="bg-gray">{{data.cascoPolicyData.customerphonenumber}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="info-item">
                                    <div class="info-item__title">მოსარგებლე</div>
                                    <div class="info-item__content">
                                        <div class="info-item__content--list">
                                            <div class="info-item__content--list-item">
                                                <div class="bg-green">სახელი,გვარი | სახელწოდება</div>
                                                <div class="bg-gray">{{data.cascoPolicyData.beneficiaryname}}</div>
                                            </div>
                                            <div class="info-item__content--list-item">
                                                <div class="bg-green">პირადი ნომერი | ს.კ</div>
                                                <div class="bg-gray">{{data.cascoPolicyData.beneficiarysoccard}}</div>
                                            </div>
                                            <div class="info-item__content--list-item">
                                                <div class="bg-green">მობილური | ტელეფონი</div>
                                                <div class="bg-gray">{{data.cascoPolicyData.beneficiaryphonenumber}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="data-table">
                <div class="data-table__title text-upp" ref="scrollTo">დაზღვეული ობიექტი (ავტოპარკი)</div>
                <div class="data-table__content" style="max-height: 720px;">
                    <table>
                        <thead>
                            <tr class="text-upp">
                                <td><div>N</div></td>
                                <td><div>მწარმოებელი |<br /> მოდელი</div></td>
                                <td><div>VIN | კოდი</div></td>
                                <td><div>წელი</div></td>
                                <td>
                                    <div>
                                        სახელმწიფო<br />
                                        ნომერი
                                    </div>
                                </td>
                                <td><div>საბაზრო<br />ღირებულება</div></td>
                                <td><div>სადაზღვევო<br />თანხა</div></td>
                                <td><div>პაკეტი</div></td>
                                <td><div>ფრანშიზა<br />სრული</div></td>
                                <td><div>ფრანშიზა<br />ნაწილობრივი</div></td>
                                <td><div>TPL ლიმიტი</div></td>
                                <td><div>MA სრული ლიმიტი |<br />1 პირზე</div></td>
                                <td><div>უ/მძღოლები</div></td>
                                <td><div>ტერიტორია</div></td>
                                <td><div>დამატებითი<br />რისკები</div></td>
                                <td><div>წლიური<br />სადაზღვევო<br />პრემია</div></td>
                                <td><div>გადახდის<br />ჯერადობა</div></td>
                                <td>
                                    <div class="flex flex-column cursor-pointer" @click="checkAll">
                                        ყველას
                                        <template v-if="isChecked">
                                            <br />მოხსნა
                                            <img src="@/assets/img/CASCO/uncheckedicon.svg" alt="" width="16">
                                        </template>
                                        <template v-else>
                                            <br />მონიშვნა
                                            <svg width="20" height="20" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                <rect width="32.252" height="32" fill="url(#pattern0_11_2405)" />
                                                <defs>
                                                    <pattern id="pattern0_11_2405" patternContentUnits="objectBoundingBox" width="1" height="1">
                                                        <use xlink:href="#image0_11_2405" transform="scale(0.00260417 0.00262467)" />
                                                    </pattern>
                                                    <image id="image0_11_2405" width="384" height="381" preserveAspectRatio="none" xlink:href="data:image/png;base64,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" />
                                                </defs>
                                            </svg>
                                        </template>
                                        
                                       
                                    

                                    </div>
                                </td>
                            </tr>
                        </thead>
                        <tbody>



                            <template v-for="(n,index) in data.cascoPolicyObjectData">



                                <tr :key="index + 1">
                                    <td><div>{{index +1}}</div></td>
                                    <td><div>{{n.carmarkvalue}}</div></td>
                                    <td><div>{{n.vincode}}</div></td>
                                    <td><div>{{n.productiondate}}</div></td>
                                    <td><div>{{n.platenumbeR1}}</div></td>
                                    <td>
                                        <div>
                                            <div class="d-flex">
                                                <span style="padding-right: 2px">{{n.currency}}</span>
                                                <span style="padding-right: 5px">{{n.marketamount}}</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div>
                                            <div class="d-flex">
                                                <span style="padding-right: 2px">{{n.currency}}</span>
                                                <span style="padding-right: 2px">{{n.insuranceamount}}</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td><div>{{n.tariffgroup}}</div></td>
                                    <td><div>{{n.riskgroupid ==146270 ?  10: 0}} %</div></td>
                                    <td><div>{{n.riskgroupid ==146270 ?  50: 0}} USD</div></td>
                                    <td>
                                        <div>
                                            <div class="d-flex">
                                                <span style="padding-right: 5px">{{n.currency}} </span>
                                                <span>{{n.tpL_AMNT}}</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td><div>{{n.aM_AMNT}} | {{n.aM_Person_AMNT}}</div></td>
                                    <td><div>{{n.driverrules}}</div></td>
                                    <td><div>{{n.countrys}}</div></td>
                                    <td>
                                        <div v-if="n.additionalRisk === 1">
                                            <img src="../assets/img/CASCO/checkedicon.svg" alt="" width="20">
                                            </div">

                                            <div v-else>
                                                <img src="@/assets/img/CASCO/uncheckedicon.svg" alt="" width="16">
                                            </div>
                                    </td>
                                    <td>
                                        <div>
                                            <div class="d-flex">
                                                <span style="padding-right: 5px"> {{n.currency}}</span>
                                                <span>{{n.insurancepremiums}}</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div>{{n.paymentcount}}</div>
                                    </td>
                                    <!--shota-->
                                    <td>
                                        <div>
                                            <div class="styled-checkbox">
                                                <input type="checkbox" :id="n.cont" @click="addApprovePolicy(n.cont)" v-model="checkedData" :value="n.cont" />
                                                <label :for="n.cont"></label>
                                            </div>
                                        </div>
                                    </td>
                                </tr>

                                <template v-if="n.mhL_NOTE != ''">
                                    <tr>
                                        <td colspan="18" class="bg-gray">
                                            <div class="justify-content-start text-upp">
                                                ✪ დაზღვევის სპეციალური პირობა
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="18">
                                            <div class="justify-content-start text-upp" style="color: #000">
                                                {{n.mhL_NOTE}}
                                            </div>
                                        </td>
                                    </tr>
                                </template>

                            </template>
                            <tr>
                                <td colspan="5" class="bg-gray color-green">
                                    <div class="justify-content-start text-upp">სულ ჯამი</div>
                                </td>
                                <td class="bg-gray color-green">
                                    <div>
                                        <div class="d-flex">
                                            <span>{{data.cascoPolicyObjectData[0].currency}}  {{data.cascoPolicyData.sumMARKETAMOUNT}}</span>
                                        </div>
                                    </div>
                                </td>
                                <td class="bg-gray color-green">
                                    <div>
                                        <div class="d-flex">
                                            <span>{{data.cascoPolicyObjectData[0].currency}} {{data.cascoPolicyData.sumINSURANCEAMOUNT}}</span>
                                        </div>
                                    </div>
                                </td>
                                <td colspan="3" class="bg-gray"><div></div></td>
                                <td class="bg-gray color-green">
                                    <div>
                                        <div class="d-flex">
                                            <span>{{data.cascoPolicyObjectData[0].currency}} {{data.cascoPolicyData.sumTPL_AMNT}}</span>
                                        </div>
                                    </div>
                                </td>
                                <td class="bg-gray color-green">
                                    <div>
                                        <div class="d-flex">
                                            <span>{{data.cascoPolicyObjectData[0].currency}} {{data.cascoPolicyData.sumAM_AMNT}}</span>
                                        </div>
                                    </div>
                                </td>
                                <td colspan="3" class="bg-gray"><div></div></td>
                                <td class="bg-gray color-green">
                                    <div>
                                        <div class="d-flex">
                                            <span>{{data.cascoPolicyObjectData[0].currency}}  {{data.cascoPolicyData.sumINSURANCEPREMIUMS}}</span>
                                        </div>
                                    </div>
                                </td>
                                <td colspan="2" class="bg-gray"><div></div></td>

                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="packages-table mt-5">
                <div class="packages-table__title text-upp">სადაზღვევო პაკეტ(ებ)ი</div>
                <div class="packages-table__content">
                    <table v-for="(n,index) in this.packetlist" :key="index">

                        <tbody>
                            <tr>
                                <td colspan=3 class="bg-green">
                                    <div>სადაზღვევო რისკების ნაკრები</div>
                                </td>
                                <td colspan=3 class="bg-lightgreen">
                                    <div class="w-100">{{n.name}}</div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan=3 class="bg-green">
                                    <div>რისკის დასახელება</div>
                                </td>
                                <td class="bg-lightgreen">
                                    <div>სტატუსი</div>
                                </td>
                                <td class="bg-lightgreen">
                                    <div>ფრანშიზა სრული</div>
                                </td>
                                <td class="bg-lightgreen">
                                    <div>ფრანშიზა<br />ნაწილობრივი</div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan=3 class="">
                                    <div>ავტომობილის დაზიანება უ/მძღოლის ბრალის გარეშე ავარიის შედეგად</div>
                                </td>
                                <td colspan=1 class="">
                                    <div class="d-flex justify-content-between">
                                        დაზღვეული
                                        <img src="../assets/img/CASCO/checkedicon.svg" alt="" width="20">
                                    </div>
                                </td>
                                <td colspan=1 class="">
                                    <div> {{n.francesca}} % </div>
                                </td>
                                <td colspan=1 class="">
                                    <div>{{n.partialfrancesca}} </div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan=3 class="">
                                    <div>ავტომობილის დაზიანება უ/მძღოლის არაუხეში ბრალით ავარიის შედეგად</div>
                                </td>
                                <td colspan=1 class="">
                                    <div class="d-flex justify-content-between">
                                        დაზღვეული
                                        <img src="../assets/img/CASCO/checkedicon.svg" alt="" width="20">
                                    </div>
                                </td>
                                <td colspan=1 class="">
                                    <div>{{n.francesca}} %</div>
                                </td>
                                <td colspan=1 class="">
                                    <div>{{n.partialfrancesca}} </div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan=3 class="">
                                    <div>ავტომობილის დაზიანება მესამე პირის მიერ (ბრალეული უცნობია)</div>
                                </td>
                                <td colspan=1 class="">
                                    <div class="d-flex justify-content-between">
                                        დაზღვეული
                                        <img src="../assets/img/CASCO/checkedicon.svg" alt="" width="20">
                                    </div>
                                </td>
                                <td colspan=1 class="">
                                    <div>{{n.francesca}} %</div>
                                </td>
                                <td colspan=1 class="">
                                    <div>{{n.partialfrancesca}} </div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan=3 class="">
                                    <div>ავტომობილის დაზიანება უ/მძღოლის უხეში ბრალით ავარიის შედეგად (იხ. სპეციალური დაფარვები)</div>
                                </td>
                                <td colspan=1 class="">
                                    <div class="d-flex justify-content-between">
                                        დაზღვეული
                                        <img src="../assets/img/CASCO/checkedicon.svg" alt="" width="20">
                                    </div>
                                </td>
                                <td colspan=1 class="">
                                    <div>{{n.francesca}} %</div>
                                </td>
                                <td colspan=1 class="">
                                    <div>{{n.partialfrancesca}} </div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan=3 class="pl-2">
                                    <span class="d-flex align-items-center">
                                        <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <rect width="40.1277" height="41" fill="url(#pattern0_5_1494)" />
                                            <defs>
                                                <pattern id="pattern0_5_1494" patternContentUnits="objectBoundingBox" width="1" height="1">
                                                    <use xlink:href="#image0_5_1494" transform="scale(0.0108696 0.0106383)" />
                                                </pattern>
                                                <image id="image0_5_1494" width="92" height="94" preserveAspectRatio="none" xlink:href="data:image/png;base64,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" />
                                            </defs>
                                        </svg>
                                        <div class="ml-2">შუქნიშნის ამკრძალავი ნიშნის დაუმორჩილებლობა ან გზაჯვარედინზე პრიორიტეტულობის დაუცველობა</div>
                                    </span>
                                </td>
                                <td colspan=1 class="">
                                    <template v-if="n.uppacket">
                                        <div class="d-flex justify-content-between">
                                            დაზღვეული
                                            <img src="../assets/img/CASCO/checkedicon.svg" alt="" width="20">
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="d-flex justify-content-between">
                                            დაუზღვეველი
                                            <img src="../assets/img/CASCO/uncheckedicon.svg" alt="" width="20">
                                        </div>
                                    </template>

                                </td>
                                <td colspan=1 class="">
                                    <div>{{n.francesca}} % </div>
                                </td>
                                <td colspan=1 class="">
                                    <div>{{n.partialfrancesca}} </div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan=3 class="pl-2">
                                    <span class="d-flex align-items-center">
                                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <rect width="40" height="40" fill="url(#pattern0_5_1496)" />
                                            <defs>
                                                <pattern id="pattern0_5_1496" patternContentUnits="objectBoundingBox" width="1" height="1">
                                                    <use xlink:href="#image0_5_1496" transform="scale(0.0108696)" />
                                                </pattern>
                                                <image id="image0_5_1496" width="92" height="92" preserveAspectRatio="none" xlink:href="data:image/png;base64,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" />
                                            </defs>
                                        </svg>
                                        <div class="ml-2">დაშვებულზე მეტი სიჩქარის განვითარება (არაუმეტეს 25 კმ/სთ)</div>
                                    </span>
                                </td>
                                <td colspan=1 class="">
                                    <template v-if="n.uppacket">
                                        <div class="d-flex justify-content-between">
                                            დაზღვეული
                                            <img src="../assets/img/CASCO/checkedicon.svg" alt="" width="20">
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="d-flex justify-content-between">
                                            დაუზღვეველი
                                            <img src="../assets/img/CASCO/uncheckedicon.svg" alt="" width="20">
                                        </div>
                                    </template>
                                </td>
                                <td colspan=1 class="">
                                    <div>{{n.francesca}} % </div>
                                </td>
                                <td colspan=1 class="">
                                    <div>{{n.partialfrancesca}} </div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan=3 class="pl-2">
                                    <span class="d-flex align-items-center">
                                        <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <rect width="41" height="41" fill="url(#pattern0_5_1498)" />
                                            <defs>
                                                <pattern id="pattern0_5_1498" patternContentUnits="objectBoundingBox" width="1" height="1">
                                                    <use xlink:href="#image0_5_1498" transform="scale(0.0121951)" />
                                                </pattern>
                                                <image id="image0_5_1498" width="82" height="82" preserveAspectRatio="none" xlink:href="data:image/png;base64,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" />
                                            </defs>
                                        </svg>
                                        <div class="ml-2">არასწორი პარკირება</div>
                                    </span>
                                </td>
                                <td colspan=1 class="">
                                    <template v-if="n.uppacket">
                                        <div class="d-flex justify-content-between">
                                            დაზღვეული
                                            <img src="../assets/img/CASCO/checkedicon.svg" alt="" width="20">
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="d-flex justify-content-between">
                                            დაუზღვეველი
                                            <img src="../assets/img/CASCO/uncheckedicon.svg" alt="" width="20">
                                        </div>
                                    </template>
                                </td>
                                <td colspan=1 class="">
                                    <div>{{n.francesca}} % </div>
                                </td>
                                <td colspan=1 class="">
                                    <div>{{n.partialfrancesca}} </div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan=3 class="pl-2">
                                    <span class="d-flex align-items-center">
                                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <rect width="40" height="40" fill="url(#pattern0_5_1500)" />
                                            <defs>
                                                <pattern id="pattern0_5_1500" patternContentUnits="objectBoundingBox" width="1" height="1">
                                                    <use xlink:href="#image0_5_1500" transform="scale(0.0108696)" />
                                                </pattern>
                                                <image id="image0_5_1500" width="92" height="92" preserveAspectRatio="none" xlink:href="data:image/png;base64,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" />
                                            </defs>
                                        </svg>
                                        <div class="ml-2">უწყვეტი ხაზის გადაკვეთა</div>
                                    </span>
                                </td>
                                <td colspan=1 class="">
                                    <template v-if="n.uppacket">
                                        <div class="d-flex justify-content-between">
                                            დაზღვეული
                                            <img src="../assets/img/CASCO/checkedicon.svg" alt="" width="20">
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="d-flex justify-content-between">
                                            დაუზღვეველი
                                            <img src="../assets/img/CASCO/uncheckedicon.svg" alt="" width="20">
                                        </div>
                                    </template>
                                </td>
                                <td colspan=1 class="">
                                    <div>{{n.francesca}} % </div>
                                </td>
                                <td colspan=1 class="">
                                    <div>{{n.partialfrancesca}} </div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan=3 class="">
                                    <div>ქურდობა</div>
                                </td>
                                <td colspan=1 class="">
                                    <div class="d-flex justify-content-between">
                                        დაზღვეული
                                        <img src="../assets/img/CASCO/checkedicon.svg" alt="" width="20">
                                    </div>
                                </td>
                                <td colspan=1 class="">
                                    <div>{{n.francesca}} % </div>
                                </td>
                                <td colspan=1 class="">
                                    <div>{{n.partialfrancesca}}</div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan=3 class="">
                                    <div>ძარცვა</div>
                                </td>
                                <td colspan=1 class="">
                                    <div class="d-flex justify-content-between">
                                        დაზღვეული
                                        <img src="../assets/img/CASCO/checkedicon.svg" alt="" width="20">
                                    </div>
                                </td>
                                <td colspan=1 class="">
                                    <div>{{n.francesca}} % </div>
                                </td>
                                <td colspan=1 class="">
                                    <div>{{n.partialfrancesca}}</div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan=3 class="">
                                    <div>ყაჩაღობა</div>
                                </td>
                                <td colspan=1 class="">
                                    <div class="d-flex justify-content-between">
                                        დაზღვეული
                                        <img src="../assets/img/CASCO/checkedicon.svg" alt="" width="20">
                                    </div>
                                </td>
                                <td colspan=1 class="">
                                    <div>{{n.francesca}} % </div>
                                </td>
                                <td colspan=1 class="">
                                    <div>{{n.partialfrancesca}} </div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan=3 class="">
                                    <div>მესამე პირის მიერ დაზიანება (განზრახ, გაუფრთხილებლობით) - "ვანდალიზმი"</div>
                                </td>
                                <td colspan=1 class="">
                                    <div class="d-flex justify-content-between">
                                        დაზღვეული
                                        <img src="../assets/img/CASCO/checkedicon.svg" alt="" width="20">
                                    </div>
                                </td>
                                <td colspan=1 class="">
                                    <div>{{n.francesca}} % </div>
                                </td>
                                <td colspan=1 class="">
                                    <div>{{n.partialfrancesca}} </div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan=3 class="">
                                    <div>დაზიანება საგნის დაცემის შედეგად</div>
                                </td>
                                <td colspan=1 class="">
                                    <div class="d-flex justify-content-between">
                                        დაზღვეული
                                        <img src="../assets/img/CASCO/checkedicon.svg" alt="" width="20">
                                    </div>
                                </td>
                                <td colspan=1 class="">
                                    <div>{{n.francesca}} % </div>
                                </td>
                                <td colspan=1 class="">
                                    <div>{{n.partialfrancesca}}</div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan=3 class="">
                                    <div>ხანძარი</div>
                                </td>
                                <td colspan=1 class="">
                                    <div class="d-flex justify-content-between">
                                        დაზღვეული
                                        <img src="../assets/img/CASCO/checkedicon.svg" alt="" width="20">
                                    </div>
                                </td>
                                <td colspan=1 class="">
                                    <div>{{n.francesca}} % </div>
                                </td>
                                <td colspan=1 class="">
                                    <div>{{n.partialfrancesca}}</div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan=3 class="">
                                    <div>აფეთქება</div>
                                </td>
                                <td colspan=1 class="">
                                    <div class="d-flex justify-content-between">
                                        დაზღვეული
                                        <img src="../assets/img/CASCO/checkedicon.svg" alt="" width="20">
                                    </div>
                                </td>
                                <td colspan=1 class="">
                                    <div>{{n.francesca}} % </div>
                                </td>
                                <td colspan=1 class="">
                                    <div>{{n.partialfrancesca}}</div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan=3 class="">
                                    <div>სტიქია</div>
                                </td>
                                <td colspan=1 class="">
                                    <div class="d-flex justify-content-between">
                                        დაზღვეული
                                        <img src="../assets/img/CASCO/checkedicon.svg" alt="" width="20">
                                    </div>
                                </td>
                                <td colspan=1 class="">
                                    <div>{{n.francesca}} % </div>
                                </td>
                                <td colspan=1 class="">
                                    <div>{{n.partialfrancesca}}</div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan=3 class="">
                                    <div>ფორს მაჟორი</div>
                                </td>
                                <td colspan=1 class="">
                                    <div class="d-flex justify-content-between">
                                        დაზღვეული
                                        <img src="../assets/img/CASCO/checkedicon.svg" alt="" width="20">
                                    </div>
                                </td>
                                <td colspan=1 class="">
                                    <div>{{n.francesca}} % </div>
                                </td>
                                <td colspan=1 class="">
                                    <div>{{n.partialfrancesca}}</div>
                                </td>
                            </tr>
                        </tbody>

                    </table>
                </div>
            </div>

            <div class="packages-table mt-5">
                <div class="packages-table__title text-upp">დამატებითი და ინოვაციური რისკები</div>
                <div class="packages-table__content">
                    <div>
                        <table style="width: 75vw">
                            <tbody>
                                <tr>
                                    <td colspan=3 class="bg-green">
                                        <div>დამატებითი რისკები</div>
                                    </td>
                                    <td colspan=1 class="bg-lightgreen">
                                        <div class="w-100">ლიმიტი</div>
                                    </td>
                                    <td colspan=1 class="bg-lightgreen">
                                        <div class="w-100">ჯერადობა</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan=3 class="pl-2">
                                        <span class="d-flex align-items-center">
                                            <img src="../assets/img/CASCO/saevakuacio.png" height="39" width="39" alt="">
                                            <div class="ml-2">საევაკუაციო მომსახურება სადაზღვევო შემთხვევისას</div>
                                        </span>
                                    </td>
                                    <td colspan=1 class="">
                                        <div>100%</div>
                                    </td>
                                    <td colspan=1 class="">
                                        <div>ულიმიტო</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan=3 class="pl-2">
                                        <span class="d-flex align-items-center">
                                            <img src="../assets/img/CASCO/saevakuacio2.png" height="39" width="39" alt="">
                                            <div class="ml-2">საევაკუაციო მომსახურება არა-სადაზღვევო შემთხვევისას</div>
                                        </span>
                                    </td>
                                    <td colspan=1 class="">
                                        <div>100%</div>
                                    </td>
                                    <td colspan=1 class="">
                                        <div>წელიწადში 2x</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan=3 class="pl-2">
                                        <span class="d-flex align-items-center">
                                            <img src="../assets/img/CASCO/sos-ardi.png" height="39" width="39" alt="">
                                            <div class="ml-2">SOS - ARDI* : ტექნიკური დახმარება გზებზე</div>
                                        </span>
                                    </td>
                                    <td colspan=1 class="">
                                        <div>100%</div>
                                    </td>
                                    <td colspan=1 class="">
                                        <div>წელიწადში 5x</div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p class="text-upp"><span>*</span> საწვავის მიწოდების, საბურავის მიწოდება-შეცვლის, ა/მ-ის დაქოქვის მომსახურების ხარჯები (თბილისი, ბათუმი, ქუთაისი, ზუგდიდი, ფოთი, თელავი, გორი და მათ მიმდებარედ 25 კმ-ის რადიუსით), თუ გამოძახებულია მზღვეველის პროვაიდერი საევაკუაციო სამსახური</p>
                    </div>
                    <div>
                        <table style="width: 75vw">
                            <tbody>
                                <tr>
                                    <td colspan=3 class="bg-purple">
                                        <div>ინოვაციური რისკები</div>
                                    </td>
                                    <td colspan=1 class="bg-purple">
                                        <div class="w-100">ლიმიტი</div>
                                    </td>
                                    <td colspan=1 class="bg-purple">
                                        <div class="w-100">ჯერადობა</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan=3 class="pl-2">
                                        <span class="d-flex align-items-center">
                                            <img src="../assets/img/CASCO/avto-shida.png" height="39" width="39" alt="">
                                            <div class="ml-2">ავტომობილის შიდა მოდიფიკაციის ქურდობა, ძარცვა, ყაჩაღობა</div>
                                        </span>
                                    </td>
                                    <td colspan=1 class="">
                                        <div>500</div>
                                    </td>
                                    <td colspan=1 class="">
                                        <div>-</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan=3 class="pl-2">
                                        <span class="d-flex align-items-center">
                                            <img src="../assets/img/CASCO/avto-piradi.png" height="39" width="39" alt="">
                                            <div class="ml-2">ავტომობილში არსებული პირადი ნივთების დაზღვევა</div>
                                        </span>
                                    </td>
                                    <td colspan=1 class="">
                                        <div>500</div>
                                    </td>
                                    <td colspan=1 class="">
                                        <div>-</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan=3 class="pl-2">
                                        <span class="d-flex align-items-center">
                                            <img src="../assets/img/CASCO/avto-shinauri.png" height="39" width="39" alt="">
                                            <div class="ml-2">ავტომობილში არსებული შინაური ცხოველის დაზღვევა (PET MA)</div>
                                        </span>
                                    </td>
                                    <td colspan=1 class="">
                                        <div>500</div>
                                    </td>
                                    <td colspan=1 class="">
                                        <div>-</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan=3 class="pl-2">
                                        <span class="d-flex align-items-center">
                                            <img src="../assets/img/CASCO/iuridiuli.png" height="39" width="39" alt="">
                                            <div class="ml-2">იურიდიული ხარჯები</div>
                                        </span>
                                    </td>
                                    <td colspan=1 class="">
                                        <div>500</div>
                                    </td>
                                    <td colspan=1 class="">
                                        <div>-</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan=3 class="pl-2">
                                        <span class="d-flex align-items-center">
                                            <img src="../assets/img/CASCO/avto-recxva.png" height="39" width="39" alt="">
                                            <div class="ml-2">ავტომობილის რეცხვის ხარჯი</div>
                                        </span>
                                    </td>
                                    <td colspan=1 class="">
                                        <div>-</div>
                                    </td>
                                    <td colspan=1 class="">
                                        <div>-</div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="packages-table mt-5">
                <div class="packages-table__title text-upp">სადაზღვევო პერიოდი</div>
                <div class="packages-table__content" style="padding-right: 50px; overflow-x: unset">
                    <table class="w-100">
                        <tbody>
                            <tr>
                                <td colspan=3 class="bg-gray">
                                    <div>{{data.cascoPolicyData.fromdateToString }}  დან</div>
                                </td>
                                <td colspan=3 class="bg-gray w-50">
                                    <div>{{data.cascoPolicyData.todateToString }}  ჩათვლით</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="packages-table mt-5">
                <div class="packages-table__title text-upp">პოლისის გაცემის საფუძვლები</div>
                <div class="packages-table__content" style="padding-right: 50px; overflow-x: unset">
                    <table class="w-100">
                        <tbody>
                            <tr>
                                <td colspan=3 class="bg-lightgreen">
                                    <div>ავტოდაზღვევის პირობები</div>
                                </td>
                                <!--<div><a href="{{data.cascoPolicyObjectData[0].linknots}}">{{data.cascoPolicyObjectData[0].linknots}}</a></div>-->
                                <td colspan=3 class="w-50">
                                    <div><a target="_blank" :href='data.cascoPolicyObjectData[0].linknots'>{{data.cascoPolicyObjectData[0].linknots}}</a></div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan=3 class="bg-lightgreen">
                                    <div>ავტოდაზღვევის გენერალური ხელშეკრულება</div>
                                </td>
                                <td colspan=3 class="w-50">
                                    <div>{{data.cascoPolicyData.generalnumber}}</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="signature-content text-upp mt-2">
                <div class="signature-text">
                    ამ დოკუმენტზე ხელმოწერით ვადასტურებ, რომ გავეცანი სს არდი დაზღვევის პირობებს (ვერსია 1.25) და ვეთანხმები მას. ამასთან, დადასტურებული დოკუმენტი, დაზღვევის პირობებთან ერთად მოიცავს საინფორმაციო შინაარსის მონაცემებს და იგი არ შეიძლება ჩაითვალოს სადაზღვევო პოლისად, ვინაიდან, თითოეული პოლისისთვის სადაზღვევო პირობა/რისკი განისაზღვრება ინდივიდუალურად.
                    ასევე, თანახმა ვარ, რომ მზღვეველმა გადაამოწმოს ჩემი პერსონალური მონაცემები სსიპ სახელმწიფო სერვისების განვითარების სააგენტოში და საჭიროების შემთხვევაში სხვა საჯარო სამსახურებში.
                </div>
                <div class="signature-btns">
                    <a @click="cancelPolicyPopup()" class="gray-btn">არ ვეთანხმები</a>
                    <a @click="approvePopup()" class="green-btn">ვეთანხმები</a>
                </div>

                <b-modal ref="approvepolicy-modal"
                         title="პოლისის მოქმედება"
                         id="approve-modal"
                         hide-footer
                         v-b-modal.modal-sm>
                    <p>დარწმუნებული ხართ?</p>
                    <div class="col-12 text-center mt-3">
                        <b-button class="mr-5" variant="danger" @click="cancelPopup()">არა</b-button>
                        <b-button variant="success"
                                  @click="submit()">
                            კი
                        </b-button>
                    </div>

                </b-modal>

                <b-modal ref="cancelpolicy-modal"
                         title="პოლისის მოქმედება"
                         id="cancel-modal"
                         hide-footer
                         v-b-modal.modal-sm>
                    <p>დარწმუნებული ხართ?</p>
                    <div class="col-12 text-center mt-3">
                        <b-button class="mr-5" variant="danger" @click="cancelPopup()">არა</b-button>
                        <b-button variant="success"
                                  @click="cancelAllPolicy()">
                            კი
                        </b-button>
                    </div>

                </b-modal>

                <div class="policy__footer mb-3">
                    <div class="d-flex justify-content-between align-items-center">
                        <img src="../assets/img/signature_footer_logo.svg" height="70" alt="">
                        <img src="../assets/img/footer-slogan-geo.svg" width="300" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>




</template>

<script>


    import Success from "./CascoSuccess";
    export default {
        name: "Contract",
        components: {
            Success,

        },
        data() {
            return {
                showSuccess: false,
                approvedLink: false,
                showCancel: false,
                canceledLink: false,
                data: null,
                cust: this.$route.params.cust,
                rowid: this.$route.params.rowid,
                list: [3, 4, 5, 6, 7, 8, 9, 10],
                isChecked: true,
                checkedData: [],
                packetlist: [],
                esignData: null,
            }
        },
        mounted() {


            this.$http.get(`/v2/polices/CheckMhlCorpCanceledLink?rowid=${this.rowid}`).then((r) => {
                this.esignData = r.data;

                if (this.esignData.status == 1) {
                    this.approvedLink = true
                }
                else if (this.esignData.status == 2) {
                    this.showCancel = true
                }
            }).catch((e) => {
                console.log(e)
            })

            this.$http.get(`/v2/polices/getCascoCorporatePolicyData?esignId=${this.rowid}&cust=${this.cust}`).then((r) => {
                this.data = r.data;
                //test
                //137918 მარდი + CORP
                //137919 მარდი

                //real
                //146228 მარდი + CORP
                //146270 მარდი

                var mardipacket = this.data.cascoPolicyObjectData.filter(a => a.riskgroupid == '146270')[0];
                var mardipluspacket = this.data.cascoPolicyObjectData.filter(a => a.riskgroupid == '146228')[0];

                if (mardipacket) {
                    this.packetlist.push({ name: mardipacket.tariffgroup, id: mardipacket.riskgroupid, francesca: 10, partialfrancesca: 50 + ' აშშ დოლარი', uppacket: false })

                }
                if (mardipluspacket) {
                    this.packetlist.push({ name: mardipluspacket.tariffgroup, id: mardipluspacket.riskgroupid, francesca: 0, partialfrancesca: 0, uppacket: true })

                }
                this.data.cascoPolicyObjectData.forEach((el) => {
                    this.checkedData.push(el.cont)
                });
            }).catch((e) => {
                console.log(e)
            })


        },

        methods: {
            cancelPopup() {
                this.$refs['approvepolicy-modal'].hide();
                this.$refs['cancelpolicy-modal'].hide();
            },
            approvePopup() {
                this.$refs['approvepolicy-modal'].show();
            },
            cancelPolicyPopup() {
                this.$refs['cancelpolicy-modal'].show();
            },
            addApprovePolicy(value) {
                if (!this.checkedData.includes(value)) {
                    this.checkedData.push(value);
                }
                else {
                    this.checkedData.splice(value, this.checkedData);
                }
            },
            checkAll() {

                if (this.isChecked) {

                    this.checkedData = [];
                    this.isChecked = false;
                } else {


                    this.checkedData.splice(0, this.checkedData.length);
                    this.data.cascoPolicyObjectData.forEach((el) => {
                        this.checkedData.push(el.cont)
                    });
                    this.isChecked = true;
                }
            },
            scrollToEl() {
                // console.log("scrollToEl")
                //scrollTo.value.scrollIntoView({ behavior: 'smooth' });
            },
            submit() {
                this.showSuccess = true;
                this.$http.post('/v2/polices/create50Doc', { conts: this.checkedData, cust: this.cust, rowid: this.rowid }
                ).then((r) => {
                    console.log(r.data)
                }).catch((e) => {
                    console.log(e)
                })
            },

            cancelAllPolicy() {
                this.showCancel = true;
                this.$http.put('/v2/polices/cancelPolicy', { conts: this.checkedData, cust: this.cust, rowid: this.rowid }
                ).then((r) => {
                    console.log(r.data)
                }).catch((e) => {
                    console.log(e)
                })
            },
        }
    }


</script>
<style>


    .tplc-policy {
        margin-top: 30px;
    }

    .tplc-policy__header {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        height: 118px;
        overflow: hidden;
        margin-bottom: 44px;
    }

        .tplc-policy__header .graphic {
            width: 200px;
            height: 100%;
            background-color: #007960;
            background-image: url("../assets/img/invoice_header_graphic.svg");
            background-size: cover;
        }

        .tplc-policy__header .title {
            background-color: #D9D8D6;
            height: 100%;
            flex: 1;
            font-feature-settings: "case" on;
            justify-content: center;
            display: FLEX;
            align-items: center;
        }

            .tplc-policy__header .title h1 {
                color: #007960;
                font-size: 26px;
                font-family: FiraGo;
                line-height: 100%;
                margin: 0;
                font-weight: 900;
            }




    .el-main {
        --el-main-padding: 0px !important;
    }

    body {
        font-family: FiraGo;
    }

    .text-upp {
        text-transform: uppercase;
        font-feature-settings: "case" on;
    }

    .casco-policy {
        margin-top: 30px;
    }

    .casco-policy__header {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        height: 118px;
        overflow: hidden;
        margin-bottom: 44px;
    }

        .casco-policy__header .graphic {
            width: 200px;
            height: 100%;
            background-color: #007960;
            background-image: url("~../assets/img/invoice_header_graphic.svg");
            background-size: cover;
        }

        .casco-policy__header .title {
            background-color: #D9D8D6;
            height: 100%;
            flex: 1;
            font-feature-settings: "case" on;
            justify-content: center;
            display: FLEX;
            align-items: center;
        }

            .casco-policy__header .title h1 {
                color: #007960;
                font-size: 26px;
                font-family: FiraGo;
                line-height: 100%;
                margin: 0;
                font-weight: 900;
            }

    .casco-policy .page-padding {
        padding-left: 50px;
        padding-right: 50px;
    }

        .casco-policy .page-padding table {
            width: 100%;
            font-size: 15px;
            font-weight: 500;
            font-feature-settings: "case" on;
        }

            .casco-policy .page-padding table thead td {
                display: flex;
            }

                .casco-policy .page-padding table thead td > div {
                    padding: 0 30px;
                    background-color: #007C6A;
                    color: #fff;
                    border: 2px solid #fff;
                    border-radius: 15px;
                    height: 50px;
                    display: flex;
                    align-items: center;
                }

                    .casco-policy .page-padding table thead td > div:first-child {
                        width: 34%;
                    }

                    .casco-policy .page-padding table thead td > div:last-child {
                        flex: 1;
                        justify-content: right;
                    }

            .casco-policy .page-padding table tbody .info-item {
                width: 100%;
                display: flex;
                flex-direction: column;
                margin-top: 14px;
            }

            .casco-policy .page-padding table tbody .info-item__title {
                border: 2px solid #007C6A;
                border-radius: 15px;
                background-color: #007960;
                color: #fff;
                width: 100%;
                height: 50px;
                padding-left: 30px;
                display: flex;
                justify-content: center;
                align-items: center;
            }

            .casco-policy .page-padding table tbody .info-item__content {
                width: 100%;
            }

            .casco-policy .page-padding table tbody .info-item__content--list {
                display: flex;
                flex-direction: column;
                margin-top: 1px;
            }

            .casco-policy .page-padding table tbody .info-item__content--list-item {
                display: flex;
            }

                .casco-policy .page-padding table tbody .info-item__content--list-item div {
                    border-radius: 15px;
                    height: 50px;
                    display: flex;
                    align-items: center;
                    padding: 0 30px;
                    border: 2px solid #fff;
                    border-bottom: 1px solid #fff;
                    border-top: 1px solid #fff;
                }

                    .casco-policy .page-padding table tbody .info-item__content--list-item div:first-child {
                        width: 34%;
                    }

                    .casco-policy .page-padding table tbody .info-item__content--list-item div:last-child {
                        flex: 1;
                        justify-content: right;
                    }

                    .casco-policy .page-padding table tbody .info-item__content--list-item div.bg-purple {
                        background-color: #BB9BC5;
                        color: #fff;
                    }

                    .casco-policy .page-padding table tbody .info-item__content--list-item div.bg-gray {
                        font-weight: 300;
                        background-color: #DEDEDE;
                        color: #000;
                    }

                        .casco-policy .page-padding table tbody .info-item__content--list-item div.bg-gray.border-gray {
                            border-color: #C9C9C9;
                        }

                    .casco-policy .page-padding table tbody .info-item__content--list-item div.bg-green {
                        background-color: #549E93;
                        border-color: #EAEAEA;
                        color: #fff;
                    }

                    .casco-policy .page-padding table tbody .info-item__content--list-item div.bg-white {
                        border-color: #549E93;
                        background-color: transparent;
                        color: #000;
                    }

                    .casco-policy .page-padding table tbody .info-item__content--list-item div a {
                        color: #000;
                        text-decoration: underline;
                    }

    .casco-policy .data-table {
        padding-left: 50px;
    }

    .casco-policy .data-table__title {
        border: 2px solid #007C6A;
        border-radius: 15px;
        background-color: #007960;
        color: #fff;
        width: calc(100% - 50px);
        height: 50px;
        margin-bottom: 2px;
        padding-left: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .casco-policy .data-table table {
        margin-bottom: 20px;
        margin-right: 50px;
    }

        .casco-policy .data-table table thead td {
            width: 1%;
            white-space: nowrap;
            padding: 0;
        }

            .casco-policy .data-table table thead td > div {
                height: 60px;
                padding: 0 30px;
                border: 1px solid #6BB5AB;
                background-color: #549E93;
                color: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
                align-items: center;
                text-align: center;
                line-height: 1;
            }

            .casco-policy .data-table table thead td:first-child > div {
                border-top-left-radius: 15px;
                border-bottom-left-radius: 15px;
            }

            .casco-policy .data-table table thead td:last-child > div {
                border-top-right-radius: 15px;
                border-bottom-right-radius: 15px;
            }

        .casco-policy .data-table table tbody tr:not(:has(input:checked)) {
            color: red;
        }

        .casco-policy .data-table table tbody td {
            width: 1%;
            white-space: nowrap;
            padding: 0;
        }

            .casco-policy .data-table table tbody td > div {
                height: 50px;
                padding: 0 30px;
                border: 1px solid #6BB5AB;
                background-color: #fff;
                color: inherit;
                display: flex;
                align-items: center;
                justify-content: center;
                align-items: center;
                text-align: center;
            }

            .casco-policy .data-table table tbody td:first-child > div {
                border-top-left-radius: 15px;
                border-bottom-left-radius: 15px;
            }

            .casco-policy .data-table table tbody td:last-child > div {
                border-top-right-radius: 15px;
                border-bottom-right-radius: 15px;
            }

            .casco-policy .data-table table tbody td.bg-gray > div {
                background: #DEDEDE;
                color: #000;
            }

            .casco-policy .data-table table tbody td.color-green > div {
                color: #007960;
                font-weight: bold;
                font-size: 1rem;
            }

        .casco-policy .data-table table .styled-checkbox {
            position: relative;
            width: 20px;
            height: 20px;
        }

            .casco-policy .data-table table .styled-checkbox input {
                position: absolute;
                left: 0;
                z-index: -1;
                width: 20px;
                height: 20px;
                opacity: 0;
            }

            .casco-policy .data-table table .styled-checkbox label {
                position: relative;
                margin-bottom: 0;
                width: 20px;
                height: 20px;
                cursor: pointer;
            }

                .casco-policy .data-table table .styled-checkbox label::before {
                    content: "";
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 20px;
                    height: 20px;
                    transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
                    pointer-events: none;
                    background-color: #fff;
                }

                .casco-policy .data-table table .styled-checkbox label::after {
                    content: "";
                    position: absolute;
                    background: 50%/50% 50% no-repeat;
                    top: 0;
                    left: 0;
                    width: 20px;
                    height: 20px;
                    background-size: 100%;
                    background-image: url(../assets/img/CASCO/uncheckedicon.svg);
                    background-size: 16px;
                }

            .casco-policy .data-table table .styled-checkbox input:checked ~ label:after {
                background-image: url(../assets/img/CASCO/checkedicon.svg);
                background-size: 100%;
            }

    .casco-policy .data-table__content {
        overflow-x: scroll;
    }

    .casco-policy .packages-table {
        padding-left: 50px;
    }

    .casco-policy .packages-table__title {
        border: 2px solid #007C6A;
        border-radius: 15px;
        background-color: #007960;
        color: #fff;
        width: calc(100% - 50px);
        height: 50px;
        margin-bottom: 2px;
        padding-left: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .casco-policy .packages-table table {
        margin-bottom: 20px;
        text-transform: uppercase;
        font-feature-settings: "case" on;
        border-spacing: 1px;
        border-collapse: separate;
        width: 90vw;
        flex: 0 0 auto;
        font-size: 0.875rem;
    }

        .casco-policy .packages-table table tbody td {
            padding: 0;
        }

            .casco-policy .packages-table table tbody td div {
                height: 50px;
                padding: 0 30px;
                border: 1px solid #6BB5AB;
                background-color: #fff;
                color: #000;
                display: flex;
                align-items: center;
                justify-content: center;
                align-items: center;
                text-align: center;
                border-radius: 15px;
                line-height: 1;
            }

                .casco-policy .packages-table table tbody td div a {
                    color: #549E93;
                    text-transform: lowercase;
                }

            .casco-policy .packages-table table tbody td.bg-green div {
                background: #007C6A;
                color: #fff;
            }

            .casco-policy .packages-table table tbody td.bg-lightgreen div {
                background: #549E93;
                color: #fff;
            }

            .casco-policy .packages-table table tbody td.bg-gray div {
                background: #DEDEDE;
                border-color: #DEDEDE;
                color: #000;
            }

            .casco-policy .packages-table table tbody td.bg-gray:first-child div {
                border-bottom-right-radius: 0;
                border-top-right-radius: 0;
            }

            .casco-policy .packages-table table tbody td.bg-gray:last-child div {
                border-bottom-left-radius: 0;
                border-top-left-radius: 0;
            }

            .casco-policy .packages-table table tbody td.bg-purple div {
                background: #BB9BC5;
                border-color: #EAEAEA;
                color: #fff;
            }

            .casco-policy .packages-table table tbody td:first-child {
                width: 50%;
            }

                .casco-policy .packages-table table tbody td:first-child div {
                    text-align: left;
                    justify-content: start;
                    flex: 1;
                }

            .casco-policy .packages-table table tbody td:nth-child(2) {
                width: 16.6666666667%;
            }

            .casco-policy .packages-table table tbody td:nth-child(3) {
                width: 16.6666666667%;
            }

            .casco-policy .packages-table table tbody td:nth-child(4) {
                width: 16.6666666667%;
            }

    .casco-policy .packages-table__content {
        overflow-x: scroll;
        display: flex;
        gap: 30px;
    }

    .casco-policy .signature-content {
        padding: 0 50px;
    }

        .casco-policy .signature-content .signature-text {
            background: #DEDEDE;
            padding: 20px;
            border-radius: 15px;
            text-align: center;
        }

        .casco-policy .signature-content .signature-btns {
            display: flex;
            justify-content: space-around;
            margin: 7rem 0;
        }

            .casco-policy .signature-content .signature-btns a {
                height: 100px;
                border-radius: 15px;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 320px;
                text-decoration: none;
                cursor: pointer;
            }

                .casco-policy .signature-content .signature-btns a.green-btn {
                    background: #007C6A;
                    color: #fff;
                }

                .casco-policy .signature-content .signature-btns a.gray-btn {
                    background: #DEDEDE;
                    color: #44484A;
                }
</style>